// extracted by mini-css-extract-plugin
module.exports = {"info":"E2eTestForm_info__1-Av5"};